import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding: 1.8rem;
    width: 45rem;
    max-height: 85vh;
    overflow-y: auto;
    font-family: 'Inter', sans-serif;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 1rem;
`

export const HeaderText = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover {
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const InputDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
`

export const LabelCreate = styled.label`
    font-weight: 600;
    font-size: 0.9rem;
`

export const InputField = styled.input`
    width: 100%;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;

    :focus {
        outline: 0;
        background-color: #E0E0E0;
    }
`

export const SelectField = styled.select`
    width: 100%;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    cursor: pointer;

    :focus {
        outline: 0;
        background-color: #E0E0E0;
    }
`

export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    justify-content: end;
    align-items: center;
    margin-top: 1.5rem;
`

export const CreateButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 5.8vh;
    padding: 1.5rem;
    background-color: #0090D3;
    color: #fff;
    border-radius: 3vw;
    cursor: pointer;

    :hover {
        background-color: #007AB8;
    }
`

export const CreateButtonImage = styled.img`
    width: 1vw;
`

export const CreateButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.5rem;
    margin-right: 0.2rem;
`

export const ErrorMessage = styled.p`
    font-size: 0.85rem;
    color: red;
    font-weight: 400;
    background-color: #FFE6E6;
    padding: 0.8rem;
    border-radius: 0.5rem;
    margin-top: 1rem;
`

export const TipText = styled.p`
    font-family: 'Inter', sans-serif;
    color: red;
    font-weight: 300;
    font-size: 0.8rem;
    margin-right: 1rem;
    margin-top: 0;
`
